import MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';
import store from '../store/store';

/**
 * Returns the calendar mailbox configuration object which is observable
 */
export default function getCalendarConfiguration(): MailboxCalendarConfiguration {
    return store.calendarConfiguration;
}
